import React from "react";
import { Link } from "react-router-dom";

interface FooterColumnProps {
  title: string;
  links: readonly { label: string; to: string }[];
}

const FooterColumn: React.FC<FooterColumnProps> = ({ title, links }) => {
  return (
    <div>
      <h3 className="mb-6 font-title text-[20px] font-[500] text-white">
        {title}
      </h3>
      <div className="flex flex-col gap-3">
        {links.map((link) => (
          <Link
            key={`${title}-${link.label}`}
            to={link.to}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className={[
              "block font-description text-[16px] font-[400] text-[#9CC0F5] hover:text-white transition-colors",
              title === "Academy" &&
              link.label === "AI Course - Prompt engineering"
                ? "max-w-[166px]"
                : "",
            ].join(" ")}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FooterColumn;
